import api from './api';

const litigesApi = {
  // Récupérer tous les litiges
  getAll: (params) => {
    return api.get('/litiges', { params });
  },

  // Récupérer un litige avec commentaires
  getById: (id) => {
    return api.get(`/litiges/${id}`);
  },

  // Créer un litige
  create: (data) => {
    return api.post('/litiges', data);
  },

  // Modifier un litige
  update: (id, data) => {
    return api.put(`/litiges/${id}`, data);
  },

  // Ajouter un commentaire
  addCommentaire: (id, commentaire, dimension) => {
    return api.post(`/litiges/${id}/commentaires`, { commentaire, dimension: dimension || null });
  },

  // Archiver un litige
  archive: (id) => {
    return api.post(`/litiges/${id}/archive`);
  },

  // Supprimer un litige
  delete: (id) => {
    return api.delete(`/litiges/${id}`);
  },

  // Récupérer les archives
  getArchives: (params) => {
    return api.get('/litiges/archives/list', { params });
  },

  // Import Excel (upsert par immatriculation)
  importRows: (rows) => api.post('/litiges/import', { rows }),

  // Stats agrégées pour le dashboard
  getStats: (params) => api.get('/litiges/stats', params ? { params } : undefined),

  // Analyse IA des litiges (superadmin uniquement)
  analyseAI: () => api.post('/ai/litiges-analyse'),

  // Analyse IA d'un dossier individuel (superadmin uniquement)
  analyseDossier: (id) => api.post(`/ai/litiges/${id}/analyse-dossier`),
};

export default litigesApi;
